export default __webpack_public_path__ + "static/media/bolt.f9d0a25b.svg";